import { getCookies } from '@shareuc/share';
import { makeAutoObservable } from 'mobx';

interface IStoreUser {
  user: string;
  username: string;
  jwt: string;
  email: string;
}

export function createStoreUser() {
  return makeAutoObservable<IStoreUser>({
    user: getCookies('shareuc_user') || '',
    username: getCookies('shareuc_username') || '',
    jwt: getCookies('shareuc_jwt') || '',
    email: getCookies('shareuc_email') || '',
  });
}

export type TStoreUser = ReturnType<typeof createStoreUser>;
